import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fator'
})
export class FatorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch (value) {
      case '0':
        return 'Abaixo de 15';
      case '1':
        return 'Entre 15 e 30';
      case '2':
        return 'Entre 35 e 50';
      case '3':
        return 'Maior que 50';
      default:
        return 'Não informado';
    }
  }

}
